import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-serif mb-2">
              精选<strong>文章</strong>
            </h2>
            <p className="text-foreground-600 text-sm">
              行业洞察与实用指南，助您了解直播新趋势
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden flex flex-col sm:flex-row hover:bg-background-200/70 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-2/5 h-48 sm:h-auto overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <span className="inline-block px-2 py-1 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-3">
                    {article.categoryName}
                  </span>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-serif mb-2 group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-4 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>·</span>
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.readTime}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}